var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{class:{ 'wrapper-mobile': true, 'ios': _vm.ios, 'android': _vm.android }})
}
var staticRenderFns = []

export { render, staticRenderFns }